import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getCommitteeOptions } from '@/module/Author/Committee';
import { CommitteeEdit } from '@/module/Author/Committee/CommitteeEdit';

export const Route = createFileRoute('/_auth/author/_author/committee/_committee/$committeeId/_layout/edit')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { committeeId } = Route.useParams();
  const { data: committee } = useSuspenseQuery(getCommitteeOptions(committeeId));

  return <CommitteeEdit committee={committee} />;
}
